import {useFormContext} from "react-hook-form";

import {Card} from "@/components/card/Card.tsx";
import {ServiceField} from "@/lib/constants/service.ts";
import {ThirdPartyServiceComponent} from "@/lib/types/checks.ts";
import {ThirdPartyComponent} from "@/pages/checks/components/form/fields/components/ThirdPartyComponent.tsx";

interface ThirdPartyNameProps {
  placeholder: string;
  thirdPartyServiceComponent: ThirdPartyServiceComponent | null;
  setThirdPartyServiceComponent: (thirdPartyServiceComponent: ThirdPartyServiceComponent | null) => void;
}

export const ThirdPartyNameField = ({
  placeholder,
  thirdPartyServiceComponent,
  setThirdPartyServiceComponent,
}: ThirdPartyNameProps) => {
  const {watch} = useFormContext();
  const checkId = watch(ServiceField.ID);

  return (
    <>
      {thirdPartyServiceComponent ? (
        <ThirdPartyComponent
          {...thirdPartyServiceComponent}
          onClick={() => {
            setThirdPartyServiceComponent(thirdPartyServiceComponent);
          }}
          disabled={Boolean(checkId)}
          className="pulse-bg-gray-50"
        />
      ) : (
        <Card className="pulseTextBodyBold text-center">
          <div className="py-3">{placeholder}</div>
        </Card>
      )}
    </>
  );
};
